module.exports = __webpack_public_path__ + "media/images/portugal_center/Ferreira_zezere-e3b1bbeba26ec49910ba9e254c83c257.jpg";